import React from 'react';
import {
  Description,
  StyledTitle,
  SubtitleWrapper,
  TitleWrapper
} from '../styled';

export const KbTitle = () => (
  <StyledTitle>Vulnerability Knowledge Base</StyledTitle>
);

export const Agents = () => (
  <StyledTitle>Runners & Security Scanners</StyledTitle>
);

export const Scheduler = () => (
  <StyledTitle>Scheduler</StyledTitle>
);

export const MCP = () => (
  <TitleWrapper>
    <StyledTitle>Connect Faraday via MCP</StyledTitle>
    <SubtitleWrapper>
      <Description>Allow AI clients to interact with your Faraday instance through the Model Context Protocol.</Description>
    </SubtitleWrapper>
  </TitleWrapper>
);
